import React from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link } from "react-router-dom";
import backgroundImage from "assets/img/marifer.png";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { MdLogout, MdPerson } from "react-icons/md";
import avatar from "assets/img/avatars/avatar4.png";
import { logout } from "utils/Firebase/firebase";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import Notification from "./components/notifications";
import readme from "docs/README.pdf";
import ThemeSelector from "components-base/style-provider/theme-selector";

const Toolbar = (props) => {
  const [darkmode, setDarkmode] = React.useState(false);
  const { userName } = useSelector(({ session }) => session);

  const pdfUrl = readme;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        background: "#ffffff",
        border: "1px solid #fce7f3",
        borderRadius: "50px",
        padding: "6px 16px",
        boxShadow: "0 4px 20px 0 rgba(244,63,94,0.12)",
      }}
    >
      <Notification />

      {/* Separador */}
      <div style={{ width: "1px", height: "28px", background: "#fce7f3", borderRadius: "2px" }} />

      <Dropdown
        button={
          <div
            style={{ cursor: "pointer", display: "flex", alignItems: "center", padding: "4px" }}
            title="Información"
          >
            <IoMdInformationCircleOutline style={{ width: 22, height: 22, color: "#f472b6" }} />
          </div>
        }
        children={
          <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
            <img style={{ width: 100, height: 100 }} src={backgroundImage} />
            <a
              target="blank"
              href={pdfUrl}
              className="px-full linear flex cursor-pointer items-center justify-center rounded-xl border py-[11px] font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:!border-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10"
            >
              Consultar la documentación
            </a>
          </div>
        }
        classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
        animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
      />

      <ThemeSelector />

      {/* Separador */}
      <div style={{ width: "1px", height: "28px", background: "#fce7f3", borderRadius: "2px" }} />

      <Dropdown
        button={
          <div style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}>
            <img
              style={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                border: "2px solid #f9a8d4",
                objectFit: "cover",
                boxShadow: "0 2px 8px rgba(244,63,94,0.2)",
              }}
              src={avatar}
              alt="Admin"
            />
            <span
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontSize: "0.78rem",
                fontWeight: 500,
                color: "#be185d",
                letterSpacing: "0.03em",
                maxWidth: 90,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {userName}
            </span>
          </div>
        }
        children={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minWidth: 220,
              borderRadius: 20,
              overflow: "hidden",
              boxShadow: "0 8px 32px rgba(244,63,94,0.18)",
              background: "white",
            }}
            className="dark:!bg-navy-700 dark:text-white"
          >
            {/* Cabecera usuario */}
            <div
              style={{
                background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
                padding: "20px 20px 16px",
                display: "flex",
                alignItems: "center",
                gap: 12,
              }}
            >
              <img
                src={avatar}
                alt="avatar"
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  border: "2px solid rgba(255,255,255,0.7)",
                  objectFit: "cover",
                }}
              />
              <div>
                <p
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 600,
                    fontSize: "0.85rem",
                    color: "#fff",
                    margin: 0,
                  }}
                >
                  {userName}
                </p>
                <p
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: "0.7rem",
                    color: "rgba(255,255,255,0.75)",
                    margin: 0,
                    letterSpacing: "0.05em",
                    textTransform: "uppercase",
                  }}
                >
                  Administrador
                </p>
              </div>
            </div>

            {/* Opciones */}
            <div style={{ padding: "8px 8px" }}>
              <button
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "10px 14px",
                  borderRadius: 12,
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: "0.82rem",
                  fontWeight: 500,
                  color: "#be185d",
                  transition: "background 0.2s",
                }}
                onMouseEnter={e => e.currentTarget.style.background = "#fce7f3"}
                onMouseLeave={e => e.currentTarget.style.background = "transparent"}
              >
                <MdPerson size={18} />
                Mi Perfil
              </button>

              <div style={{ height: "1px", background: "#fce7f3", margin: "4px 0" }} />

              <button
                onClick={() => logout()}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "10px 14px",
                  borderRadius: 12,
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: "0.82rem",
                  fontWeight: 500,
                  color: "#e11d48",
                  transition: "background 0.2s",
                }}
                onMouseEnter={e => e.currentTarget.style.background = "#fff1f2"}
                onMouseLeave={e => e.currentTarget.style.background = "transparent"}
              >
                <MdLogout size={18} />
                Cerrar sesión
              </button>
            </div>
          </div>
        }
        classNames={"py-2 top-8 -left-[180px] w-max"}
      />
    </div>
  );
};

export default Toolbar;
